var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinhaConta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5355 1.465C12.5979 0.52625 11.3261 0 10 0C8.67387 0 7.40212 0.52625 6.4645 1.465C5.52675 2.4025 5 3.67375 5 5C5 6.32625 5.52675 7.5975 6.4645 8.535C7.40212 9.47375 8.67387 10 10 10C11.3261 10 12.5979 9.47375 13.5355 8.535C14.4732 7.5975 15 6.32625 15 5C15 3.67375 14.4732 2.4025 13.5355 1.465ZM20 17.5C20 14.7375 15.525 12.5 10 12.5C4.475 12.5 0 14.7375 0 17.5V20H20V17.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5355 1.465C12.5979 0.52625 11.3261 0 10 0C8.67387 0 7.40212 0.52625 6.4645 1.465C5.52675 2.4025 5 3.67375 5 5C5 6.32625 5.52675 7.5975 6.4645 8.535C7.40212 9.47375 8.67387 10 10 10C11.3261 10 12.5979 9.47375 13.5355 8.535C14.4732 7.5975 15 6.32625 15 5C15 3.67375 14.4732 2.4025 13.5355 1.465ZM20 17.5C20 14.7375 15.525 12.5 10 12.5C4.475 12.5 0 14.7375 0 17.5V20H20V17.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinhaConta);
export default __webpack_public_path__ + "static/media/minha-conta.a94d91f54f6c037262587db5ee0836d7.svg";
export { ForwardRef as ReactComponent };